
namespace TabAurous.Production {

    @Serenity.Decorators.registerClass()
    export class DismantlingItemsSelectGrid extends _Ext.GridBase<DismantlingItemsRow, any> {
        protected getColumnsKey() { return 'Production.DismantlingItems'; }
        protected getDialogType() { return <any>DismantlingItemsDialog; }
        protected getIdProperty() { return DismantlingItemsRow.idProperty; }
        //protected getLocalTextPrefix() { return DismantlingItemsRow.localTextPrefix; }
        //protected getService() { return JobWorkDismantlingItemsService.baseUrl; }
         
        constructor(container: JQuery,options) {
            super(container, options);
            this.rowSelection = new Serenity.GridRowSelectionMixin(this);
            new Serenity.HeaderFiltersMixin({
                grid: this
            });
            return this;
        }

        private autoSize;
 
        // *** Resizes the columns after changes are made to the grid (ex. Column Picker) *
        protected markupReady() {
            super.markupReady();
            if (this.autoSize != null) {
                this.autoSize.resizeAllColumns();
            }
        }

        get selectedItems(): DismantlingItemsRow[] {
            var _this = this;
            return this.rowSelection.getSelectedAsInt32().map(function (x) { return _this.view.getItemById(x); });
        }

        protected usePager() { return false; };
        protected getInitialTitle() { return null; };

        protected getButtons() {
            var buttons = super.getButtons.call(this);
            buttons = buttons.filter(function (x) { return x.cssClass != 'add-button'; });
            return buttons;
        };


        protected onViewSubmit() {

            if (!super.onViewSubmit.call(this))
                return false;
            //var request = this.view.params;
            //if (this.options.hideProducts && this.options.hideProducts.length)
            //    request.Criteria = Serenity.Criteria.and(request.Criteria, [["ProductID" /* ProductID */], 'not in', [this.options.hideProducts]]);
            return true;

        }

    } 
}